import React from "react";
// import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import logo from "../../../assets/images/bgImage.jpg";
import { Divider } from "@mui/material";
import { YouTube } from "@mui/icons-material";
import { FaInstagram, FaYoutube } from "react-icons/fa";
import { FaFacebook, FaTwitter, FaXTwitter } from "react-icons/fa6";
import { ArrowBack } from "@mui/icons-material"; // Import back arrow icon
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function FodSourceAffiliationDetail() {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(-1);
  };

  const partner = {
    name: "Booking.com",
    sector: "Information Technology",
    location: "Dublin",
    established: "1996",
    website: "https://careers.booking.com/",
    image: logo, // Replace with the actual image path
  };

  return (
    <div className="container-fluid justify-content-center ">
      <div className="mt-3">
        <div className="card shadow-md p-4 card-padding">
          <div className="row g-4">
            {/* Left Side Content */}
            <div className="col-md-6">
              <div className="d-flex">
                {" "}
                <div
                  className=" heading-main container  mb-4 "
                  style={{ marginLeft: "0px", paddingLeft: "0px" }}
                >
                  <h2>{partner.name}</h2>
                </div>
                {/* <h4
                  className="fw-bold mb-4 "
                ></h4> */}
              </div>

              <hr />

              <div className="info-section detail-page-text">
                <p>
                  <strong>Sector</strong>{" "}
                  <span className="text-muted">{partner.sector}</span>
                </p>
                <Divider />
                <p>
                  <strong>Location</strong>{" "}
                  <span className="text-muted">{partner.location}</span>
                </p>
                <Divider />
                <p>
                  <strong>Established in</strong>{" "}
                  <span className="text-muted">{partner.established}</span>
                </p>
                <Divider />
                <p>
                  <strong>Website</strong>{" "}
                  <a
                    href={partner.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary"
                  >
                    {partner.website}
                  </a>
                </p>
                <Divider />
              </div>

              {/* Social Media Icons */}
              <div
                className="d-flex gap-4 mt-3"
                style={{ justifyContent: "end" }}
              >
                <FaYoutube size={25} fontSize="large" />
                <FaFacebook size={25} fontSize="large" />
                <FaTwitter size={25} fontSize="large" />
                <FaInstagram size={25} fontSize="large" />
              </div>
            </div>

            {/* Right Side Image */}
            <div className="col-md-6 col-sm-4 d-flex justify-content-center align-items-center">
              <img
                src={partner.image}
                alt={partner.name}
                className="rounded-3 shadow-sm"
                style={{
                  width: "100%", // Makes the image responsive
                  maxWidth: "450px", // Limits max size on larger screens
                  height: "auto", // Maintains aspect ratio
                  maxHeight: "300px", // Prevents excessive height
                  objectFit: "cover",
                  marginTop: "70px",
                  marginLeft: "auto", // Centers image properly
                  marginRight: "auto", // Centers image properly
                }}
              />
            </div>
          </div>
        </div>
        <div
          className="card shadow-md p-4 mt-3 mb-4 about-content"
          style={{ marginLeft: "14px" }}
        >
          <h4 className="fw-bold mb-4 container ">About</h4>
          <p className="container">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has ever since the
            1500s, when an unknown printer took a galley of type 1500s, when an
            unknown printer took a galley of type 1500s, when an unknown printer
            took a galley of type
          </p>
        </div>
      </div>
    </div>
  );
}
